import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import classnames from 'classnames';
import React from 'react';
import styles from './form-checkbox.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export var FormCheckbox = function FormCheckbox(_ref) {
  var active = _ref.active,
      className = _ref.className;
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.checkbox, className, _defineProperty({}, styles.active, active))
  });
};